/**
 * Stores build information. The string literals are replaces at compile time by `set_version.js`.
 */
export const buildInfo = {
    versionNumber: "0.1.0",
    versionName: "nightly 2023-04-29",
    versionChannel: "nightly",
    buildDate: "2023-04-29T00:18:29.762Z",
    commitHash: "1f956ffe55525657dc4748ce39861a995c2fe2a9",
};
